// removed by extract-text-webpack-plugin
module.exports = {"vpRichText":"vpRichText___VlIrK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/RichText.module.less
// module id = 3797
// module chunks = 33